import { KeycloakService } from 'keycloak-angular';
import { firstValueFrom, Observable } from 'rxjs';
import { Environment } from 'src/environments/environment.model';

export function keycloakInitializer(
  env$: Observable<Environment>,
  keycloak: KeycloakService
): () => Promise<void> {
  return async (): Promise<void> => {
    const environment = await firstValueFrom(env$);
    if (environment.settings.keycloak === false) {
      return Promise.resolve();
    }
    const keycloakOptions = {
      ...environment.settings.keycloak,
      silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
    };
    await keycloak.init(keycloakOptions).then(
      () => {
        console.debug('SSO Initialized');
        if (window.location.hash.includes('#iss')) {
          const cleanUrl = window.location.origin + window.location.pathname;
          window.history.replaceState(null, '', cleanUrl);
        }
      },
      (e) => {
        console.error('SSO Initialization Failed:', e);
        throw e;
      }
    );
  };
}
